<form #generateForm="ngForm">
  <!-- Step 1: School Year -->
  <div class="mb-3" *ngIf="generateFormFlags.showYear">
    <label class="form-label">Annual School Year <span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="generateFormData.schoolYear" name="schoolYear" (change)="onYearChange()">
      <option value="" disabled selected>Select year</option>
      <option *ngFor="let year of getFoodAuditYears()" [value]="year">{{ year }}</option>
    </select>
  </div>

  <!-- Step 2: Choose Scope -->
  <div class="mb-3" *ngIf="generateFormFlags.showScope">
    <label class="form-label">Choose From <span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="generateFormData.scope" name="scope" (change)="onScopeChange()">
      <option value="" disabled selected>Select</option>
      <option value="school">School</option>
      <option value="cluster">Cluster</option>
      <option value="all">All Schools</option>
    </select>
  </div>

  <!-- Step 3: Conditional School selection -->
  <div class="mb-3" *ngIf="generateFormFlags.showSelection && generateFormData.scope !== 'cluster' && generateFormData.scope != 'all'">
    <label class="form-label">{{generateFormData.selectionLabel}} <span class="required">*</span></label>
    <select class="form-select" [(ngModel)]="generateFormData.selection" name="selection">
      <option value="" disabled selected>Select option</option>
      <option *ngFor="let opt of generateFormData.selectionOptions" [value]="opt">{{ opt }}</option>
    </select>
  </div>

  <!-- Conditional Cluster selection -->
  <div class="mb-3" *ngIf="generateFormData.scope === 'cluster'">
    <div *ngFor="let opt of generateFormData.selectionOptions" class="form-check">
      <input class="form-check-input" type="checkbox" [id]="opt" [checked]="Array.isArray(generateFormData.selection) && generateFormData.selection.includes(opt)" (change)="toggleCluster(opt, $event)">
      <label class="form-check-label" [for]="opt">{{ opt }}</label>
    </div>
  </div>

  <!-- Generate Button -->
  <div *ngIf="generateFormFlags.showSelection || generateFormData.scope === 'all'">
    <button type="button" class="btn generate-btn" [disabled]="!canGenerate()" (click)="generatePdf()">
      Generate Report
    </button>
  </div>
</form>
